export class EmailSettingsModel {

    public imapHost: string;
    public smtpHost: string;
    public imapPort: string;
    public smtpPort: string;
    public smtpSecure: boolean;
    public login: string;
    public password: string;
    
    constructor(obj?: any) {
        this.imapHost   = obj && obj.imapHost   || '';
        this.smtpHost   = obj && obj.smtpHost   || '';
        this.imapPort   = obj && obj.imapPort   || '993';
        this.smtpPort   = obj && obj.smtpPort   || '2525';
        this.smtpSecure = obj && obj.smtpSecure || false;
        this.login      = obj && obj.login      || '';
        this.password   = obj && obj.password   || '';
      
    }
}



// WEBPACK FOOTER //
// ./src/app/models/email-settings.model.ts